import {
  SET_CONVERSATION_ATTRIBUTES,
  UPDATE_CONVERSATION_ATTRIBUTES,
  UPDATE_CONVERSATION_QUEUE_STATUS,
  CLEAR_CONVERSATION_ATTRIBUTES,
  UPDATE_CONVERSATION_ARCHIVE_STATUS,
  UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES,
  SET_LOCAL_STORAGE_CONVERSATION_ATTRIBUTES,
} from '../types';
import { getConversationAPI } from '../../api/conversation';
import { LocalStorage } from '../../../shared/helpers/localStorage';
import { getLastConversationLSKey } from '../../helpers/urlParamsHelper';

const state = {
  id: '',
  did: '',
  status: '',
  in_queue: undefined,
  archived: null,
  customAttributes: null,
};

export const getters = {
  getConversationParams: $state => {
    return $state;
  },
  getCurrentConversationId: $state => {
    return $state.id;
  },
};

export const actions = {
  getAttributes: async ({ commit }) => {
    /**
     * Use API to get conversation attributes
     */
    try {
      const { data } = await getConversationAPI();
      const { contact_last_seen_at: lastSeen } = data;
      commit(SET_CONVERSATION_ATTRIBUTES, data);
      commit('conversation/setMetaUserLastSeenAt', lastSeen, { root: true });
      return data;
    } catch (error) {
      // Ignore error
    }
    return null;
  },
  set({ commit }, data) {
    commit(SET_CONVERSATION_ATTRIBUTES, data);
  },
  setLocalStorage({ commit }, data) {
    commit(SET_LOCAL_STORAGE_CONVERSATION_ATTRIBUTES, data);
  },
  update({ commit, state: $state }, data) {
    if (data?.id === $state?.did) {
      commit(UPDATE_CONVERSATION_ATTRIBUTES, data);
    } else {
      commit(
        'conversation/changeConversationStatusList',
        {
          status: data.status,
          conversationId: data.id,
        },
        { root: true }
      );
    }
  },
  updateQueueStatus({ commit }, data) {
    commit(UPDATE_CONVERSATION_QUEUE_STATUS, data);
  },
  updateArchivedStatus({ commit }, data) {
    commit(UPDATE_CONVERSATION_ARCHIVE_STATUS, data);
  },
  updateCustomAttributes({ commit }, data) {
    commit(UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES, data);
  },
  clearConversationAttributes: ({ commit }) => {
    commit('CLEAR_CONVERSATION_ATTRIBUTES');
  },
};

function storeConversationAttributes(data) {
  LocalStorage.set(getLastConversationLSKey(), data);
}

export const mutations = {
  [SET_CONVERSATION_ATTRIBUTES]($state, data) {
    storeConversationAttributes(data);
    window.hooryCurrentConversation = data.id;
    window.hooryCurrentConversationDid = data.did || data.display_id;
    $state.id = data.id;
    $state.did = data.did;
    $state.status = data.status;
    $state.in_queue = data.in_queue;
    $state.archived = data.archived;
    $state.customAttributes = data.customAttributes || data.custom_attributes;
  },
  [SET_LOCAL_STORAGE_CONVERSATION_ATTRIBUTES]($state, data) {
    storeConversationAttributes(data);
  },
  [UPDATE_CONVERSATION_ATTRIBUTES]($state, data) {
    if (data?.id === $state.did) {
      storeConversationAttributes(data);
      if (data.id) $state.id = data.id;
      if (data.did) $state.did = data.did;
      if (data.status) $state.status = data.status;
      if (typeof data.in_queue !== 'undefined') $state.in_queue = data.in_queue;
      if (typeof data.archived !== 'undefined') $state.archived = data.archived;
      $state.customAttributes = data.customAttributes;
    } else if (this.dispatch)
      this.dispatch('conversation/changeConversationStatusList', {
        status: data.status,
        conversationId: data.id,
      });
  },
  [UPDATE_CONVERSATION_QUEUE_STATUS]($state, { in_queue }) {
    $state.in_queue = in_queue;
  },
  [UPDATE_CONVERSATION_ARCHIVE_STATUS]($state, { archived }) {
    $state.archived = archived;
  },
  [UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES]($state, { customAttributes }) {
    $state.customAttributes = customAttributes;
  },
  [CLEAR_CONVERSATION_ATTRIBUTES]($state) {
    storeConversationAttributes({});
    $state.id = '';
    $state.did = '';
    $state.status = '';
    $state.in_queue = undefined;
    $state.archived = null;
    $state.customAttributes = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
